/**
 * Stateful utilities for the teacher upsell from content pages.
 */
import * as Cookies from "@khan/data-cookies";
import {PermissionsInfo, RequestInfo} from "@khan/shared-core";

const DISMISS_COOKIE = "growth_teacher_content_upsell_dismissed";

const dismiss = (): boolean =>
    Cookies.createCookie(DISMISS_COOKIE, Cookies.CookieCategory.Functional, 1);

// TODO(csilvers): pass in a Cookies and KA object rather than
// reading them globally, to make it clearer these aren't SSR-safe.
const hasDismissed = (forceContentUpsellPopup?: string | null) => {
    return !forceContentUpsellPopup && !!Cookies.readCookie(DISMISS_COOKIE);
};

const isElligible = () => !PermissionsInfo.isLoggedIn && !RequestInfo.isMobile;

const shouldShowPopup = (forceContentUpsellPopup?: string | null): boolean =>
    !hasDismissed(forceContentUpsellPopup) && isElligible();

export default {dismiss, shouldShowPopup};
